import * as React from 'react';
import { Code } from 'react-content-loader';
import { Config } from '../helper';

export default function Footer(props) {
  const {
    content,
  } = props;

  if (!content) {
    return null;
  }

  return (
    <div className='extra-resources'>
      <div className='extra-resources__content' dangerouslySetInnerHTML={{__html: content}}></div>
    </div>
  );
}

function Card() {
  return (
    <div className='card'>
      <div className='card__content'>
        <div className='mb-2'><Code/></div>
        <div className='mb-2'><Code/></div>
        <div className='mb-0'><Code/></div>
      </div>
    </div>
  );
}

export function Preloader() {
  return null;
  return (
    <div className='extra-resources'>
      <div className="extra-resources__content">
        <h3 className="h--small m-3 mx-0">{Config.I18n.FooterDefaultLabel}:</h3>
        <div className='row'>
          <div className='col-lg-4 col-sm-12 mb-3'>
            <Card/>
          </div>
          <div className='col-lg-4 col-sm-12 mb-3'>
            <Card/>
          </div>
          <div className='col-lg-4 col-sm-12 mb-3'>
            <Card/>
          </div>
        </div>
      </div>
    </div>
  );
}
